import React from 'react';
import { Table } from 'antd';
import './styles/my-table.scss';

const MyTable = ({
  scroll,
  pagination,
  className = '',
  shellClassName = '',
  dataSource = [],
  ...props
}) => {
  const computedTotalRows =
    pagination && pagination !== false && typeof pagination.total === 'number'
      ? pagination.total
      : Array.isArray(dataSource)
        ? dataSource.length
        : 0;

  const mergedPagination =
    pagination === false
      ? false
      : {
          showSizeChanger: true,
          pageSizeOptions: ['10', '25', '50', '100'],
          ...pagination,
        };

  return (
    <div className={`my-table-shell ${shellClassName}`.trim()}>
      <Table
        className={`my-table ${className}`.trim()}
        scroll={{
          y: 520,
          x: 'max-content',
          ...scroll,
        }}
        dataSource={dataSource}
        pagination={mergedPagination}
        {...props}
      />

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: -18,
          paddingRight: 20,
          paddingBottom: 12,
          fontSize: 14,
          fontWeight: 700,
        }}
      >
        Count: {computedTotalRows}
      </div>
    </div>
  );
};

export default MyTable;